import { createReducer } from '@reduxjs/toolkit';
import { closeEditTranslationComponent, showEditTranslationComponent, translatedFileReplacement } from 'redux/actions/edit-translations';
import { EditableCourseElements } from 'redux/schemas/models/edit-translations';
import { AccordionLectureComponentData, ComponentType, LectureComponent, NLectureComponent } from 'redux/schemas/models/lecture-component';
import { CourseOutlineItem, LectureOutlineItem } from 'redux/selectors/course-outline/course-outline-item';
import { Attachment } from 'redux/schemas/models/attachment';
import { initialRootState } from '.';

export default createReducer(initialRootState, builder => {
  builder
    .addCase(showEditTranslationComponent, (state, action) => {
      let editViewOptions;
      let dataContent;
      let lectureSectionId;
      let lectureSubsectionId;

      const editableCourseElements = Object.values(EditableCourseElements) as string[];
      if (editableCourseElements.includes(action.payload.type)) {
        dataContent = (action.payload.component as CourseOutlineItem).name;
        if (action.payload.type === EditableCourseElements.LESSON) {
          if ((action.payload.component as LectureOutlineItem).sectionType === 'section') {
            lectureSectionId = (action.payload.component as LectureOutlineItem).section;
          } else {
            lectureSubsectionId = (action.payload.component as LectureOutlineItem).section;
          }
        }
      } else {
        editViewOptions = (action.payload.component as LectureComponent).viewOptions;
        if (action.payload.type === ComponentType.ACCORDION) {
          // For Accordions we need to get the array of sections,
          // and for the rest, it's just text.
          dataContent = (action.payload.component as AccordionLectureComponentData).accordionSections;
        } else {
          dataContent = (action.payload.component as LectureComponent).content;
        }
      }
      const info = {
        type: action.payload.type,
        trueType: action.payload.trueType,
        content: dataContent,
        viewOptions: editViewOptions,
        id: action.payload.component.id,
        // In case it's a course element
        lectureSectionId,
        lectureSubsectionId,
      };
      state.app.editTranslationInfo = info;
    })
    .addCase(closeEditTranslationComponent, (state, action) => {
      state.app.editTranslationInfo = null;
    })
    .addCase(translatedFileReplacement.fulfilled, (state, action) => {
      if (action.payload) {
        const { lectureComponentId } = action.meta.arg;
        const payloadAttachment = action.payload;
        const currentAttachment = (state.models.attachments[action.meta.arg.attachmentId] as unknown as Attachment);

        (state.models.attachments[action.meta.arg.attachmentId] as unknown as Attachment) = {
          ...currentAttachment,
          autoTranslated: {
            lectureComponentId,
            attachmentId: payloadAttachment.id,
            boxDocumentId: payloadAttachment.file.boxDocumentId,
            translatedFromId: action.meta.arg.attachmentId,
            documentName: payloadAttachment.file.name,
            documentUrl: payloadAttachment.file.url,
            errorCode: null,
            language: action.meta.arg.language,
            status: 'completed',
            manuallyTranslated: true,
            thumbnailUrl: payloadAttachment.file.thumbnailUrl,
            size: payloadAttachment.file.size,
          },
        };
        state.models.lectureComponents[lectureComponentId] = {
          ...state.models.lectureComponents[lectureComponentId],
          aiEdited: true,
        };
      }
    });
});
